import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { DayOfWeek } from '../../common/models/CommonModels';
import { renderCheckbox, renderErrorInfoText } from '../../common/forms/FieldCreators';
import { Control, Fieldset, Errors } from 'react-redux-form';
import FormItem from '../forms/FormItem';
import { localizations } from '../../localization/localization';
import { EveryNthOccurence } from './EveryNthOccurence';

interface WeeklyControlProps {
    errorModelName: string;
    disabled: boolean;
}

const WeeklyControls = (props: WeeklyControlProps) => {
    return (
        <Grid item>
            <Grid container justify="flex-start" direction="column">
                <Grid item>
                    <Typography>{localizations.recurrence.weekdays}</Typography>
                    <Fieldset model=".weekdays">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <FormControlLabel
                                            control={
                                                <Control.checkbox
                                                    model={`.${DayOfWeek.Monday}`}
                                                    component={renderCheckbox}
                                                    disabled={props.disabled}
                                                />
                                            }
                                            label={localizations.days[DayOfWeek.Monday]}
                                        />
                                    </td>
                                    <td>
                                        <FormControlLabel
                                            control={
                                                <Control.checkbox
                                                    model={`.${DayOfWeek.Tuesday}`}
                                                    component={renderCheckbox}
                                                    disabled={props.disabled}
                                                />
                                            }
                                            label={localizations.days[DayOfWeek.Tuesday]}
                                        />
                                    </td>
                                    <td>
                                        <FormControlLabel
                                            control={
                                                <Control.checkbox
                                                    model={`.${DayOfWeek.Wednesday}`}
                                                    component={renderCheckbox}
                                                    disabled={props.disabled} 
                                                />
                                            }
                                            label={localizations.days[DayOfWeek.Wednesday]}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <FormControlLabel
                                            control={
                                                <Control.checkbox
                                                    model={`.${DayOfWeek.Thursday}`}
                                                    component={renderCheckbox}
                                                    disabled={props.disabled}
                                                />
                                            }
                                            label={localizations.days[DayOfWeek.Thursday]}
                                        />
                                    </td>
                                    <td>
                                        <FormControlLabel
                                            control={
                                                <Control.checkbox
                                                    model={`.${DayOfWeek.Friday}`}
                                                    component={renderCheckbox}
                                                    disabled={props.disabled}
                                                />
                                            }
                                            label={localizations.days[DayOfWeek.Friday]}
                                        />
                                    </td>
                                    <td>
                                        <FormControlLabel
                                            control={
                                                <Control.checkbox
                                                    model={`.${DayOfWeek.Saturday}`}
                                                    component={renderCheckbox}
                                                    disabled={props.disabled}
                                                />
                                            }
                                            label={localizations.days[DayOfWeek.Saturday]}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <FormControlLabel
                                            control={
                                                <Control.checkbox
                                                    model={`.${DayOfWeek.Sunday}`}
                                                    component={renderCheckbox}
                                                    disabled={props.disabled}
                                                />
                                            }
                                            label={localizations.days[DayOfWeek.Sunday]}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <Errors
                            model={props.errorModelName}
                            show={{ touched: true, focus: false }}
                            messages={{ isWeekdaySelected: localizations.recurrence.selectWeekday }}
                            wrapper={renderErrorInfoText}
                        />
                    </Fieldset>
                </Grid>
                <Grid item>
                    <FormItem>
                        <EveryNthOccurence
                            preInputText={localizations.recurrence.everyNthPreInput}
                            disabled={props.disabled}
                            postInputText={localizations.recurrence.weeklyEveryNthPostInput}
                        />
                    </FormItem>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default WeeklyControls;


// WEBPACK FOOTER //
// ./src/components/recurrence/WeeklyControls.tsx